<template>
  <div class="cnomert">
    <!-- <div class="headersts">
      <img src="../../../../../assets/images/home/logo.png" class="imgsts" alt @click="retrungo()" />
      <span style="cursor: pointer;margin-left:5px" @click="retrungo()">学堂科技教育训练网络学院</span>
    </div>-->
    <vsmallheader></vsmallheader>

    <div class="towheder" v-if="Detailflg">
      <div class="towhedercente">
        <div class="twohederTitle"></div>
        <div class="towhedrdetail">
          <img :src="Detail.imgUrl" />
          <div class="towdetailright">
            <div class="towdetailtops">
              <p class="towdetailtopstxt">{{Detail.name}}</p>
              <p>
                <span class="score">{{Detail.score}}</span> 分
              </p>
            </div>

            <div class="towdetaillef">
              <p>警种：{{Detail.jzName}}</p>
              <i>|</i>
              <p>来源：{{Detail.deptName}}</p>
              <i>|</i>
              <p>发布：{{Detail.pulishTime}}</p>
            </div>

            <div class="giveNumber">
              <div class="givel"></div>
              <div class="givenumberright">
                <div class="giveimg">
                  <img src="@/assets/videoimg/studycommentylActive.svg" />
                  {{Detail.cataCount}}
                </div>
                <div class="giveimg">
                  <img src="@/assets/images/traningschool/videoplimg.png" />
                  {{Detail.talkCount}}
                </div>
                <div class="giveimg">
                  <img src="@/assets/videoimg/give.svg" />
                  <!-- <img src="@/assets/images/traningschool/videoplimg.png" /> -->
                  {{Detail.assistCount}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="classdetailtab">
      <ul class="ulisact">
        <li
          :class="{isactives :index==cateId}"
          :style="{color: index==cateId? '#027db4' : ''}"
          v-for="(item,index) in tablisttow"
          :key="index"
          @click="handleClicktab(index)"
        >{{item.title}}</li>
      </ul>
    </div>

    <!-- 课程章节 -->
    <div v-if="cateId==0" class="classcouestboxsum">
      <div class="brieftext">{{Detail.introduce}}</div>
      <div class="classcouest">
        <div class="classcouestleft">
          <nodata v-if="Treelist.length<1"></nodata>
          <div class="classcouestleftli" v-for="(item,index) in Treelist" :key="index">
            <div class="classjd">{{item.name}}</div>

            <div class v-for="(items,indexs) in item.subList" :key="indexs">
              <div class="sounname">{{items.name}}</div>
              <div
                class="sounImgbox"
                v-for="(itemsl,indexsl) in items.fileList"
                :key="indexsl"
                @click="source(item.id,items.id,itemsl.id)"
              >
                <div class="tag" v-if="itemsl.type==1">视频</div>
                <div class="tag" v-if="itemsl.type==2">文档</div>
                <div class="tag" v-if="itemsl.type==3">习题</div>
                <div class="sourconts">{{itemsl.name}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="classcouestright">
          <!-- <div class="classcouestrighthed">
            <div class="classcouestrightheditem">
              <label>已学 27%</label>
              <div>上次学到：1.1 地方政府的界定</div>
            </div>
            <div class="progress">
              <ins data-progress="0" style="display: inline-block;" :style="{ width: 50 + '%' }"></ins>
            </div>
            <div class="studyx">继续学习</div>
          </div>-->

          <div class="techliNamehed">授课讲师</div>
          <div class="lecturerbox">
            <div
              class="lecturer"
              v-for="(item,index) in TeacherInfo "
              :key="index"
              @click="teacke(item.id)"
            >
              <img :src="item.photo" class="teachImgs" />
              <div class="lectureName">
                <h4>{{item.name}}</h4>
                <div class="lecturegrade">{{item.typeDicName}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 评论 -->
    <div class="introducel" v-if="cateId==1">
      <nodata v-if="MoocTalkLoadlist.length<1"></nodata>
      <div class="gaishu" v-for="(item,index) in MoocTalkLoadlist" :key="index">
        <img class="gaiimg" :src="item.photo" />
        <div class="gaisuflex">
          <div class="gaisuname">{{item.createName}}</div>
          <div class="gaisutext">{{item.message}}</div>
          <div class="giveclbox">
            <div></div>
            <span class="give-time">{{item.createTime}}</span>
          </div>
        </div>
      </div>
      <div class="bottomPate">
        <el-pagination
          layout="total,prev, pager, next"
          :page-size="pageSize"
          background
          :total="countlist"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          v-if="countlist>pageSize"
        ></el-pagination>
      </div>
    </div>

    <!--课后练习  -->
    <div class="exercisebox" v-if="cateId==2">
      <nodata v-if="GetLearnDetaillist.length<1"></nodata>
      <div v-if="routeFlag">
        <div class="exerciseli" v-for="(item,index) in GetLearnDetaillist" :key="index">
          <label>{{item.name}}</label>
          <div class="exerciseitem">
            <div class="exerciseitemflex">
              <li>习题数量：{{item.cnt}}</li>
            </div>
            <div class="exerciseitemRight">
              <div class="exerciseitemBtn" @click="goexerciseitem(item.id)">前往练习</div>
            </div>
          </div>
        </div>
      </div>
      <exerciselistExam v-else :Id="ids" @Close="Close"></exerciselistExam>
    </div>

    <!-- 资源下载 -->
    <div class="downloadbox" v-if="cateId==3">
      <nodata v-if="MoocGetDownListlist.length<1"></nodata>
      <div class="downloadli" v-for="(item,index) in MoocGetDownListlist" :key="index">
        <label class="downtxt">{{item.name}}</label>
        <div class="downbtn" @click="downloadNow(item.id)">立即下载</div>
      </div>
    </div>
    <!-- <linecom></linecom> -->
  </div>
</template>

<script>
import vsmallheader from '@/views/smallHeader/index';
import { getInfo } from '@/utils/auth';
import HeaderDateil from './HeaderDateil/index';
import exerciselistExam from './exerciselistExam/index';
import * as studyClassIndex from '@/api/studyClass/index';
import linecom from '@/components/linecom/index';
export default {
  components: { vsmallheader, HeaderDateil, exerciselistExam, linecom },
  data() {
    return {
      answers: '',
      ids: '',
      Treelist: [],
      Detail: '',
      GetLearnDetaillist: [],
      tablisttow: [
        { title: '课程章节', id: 0 },
        { title: '评论', id: 1 },
        { title: '课后练习', id: 2 },
        { title: '资料下载', id: 3 },
      ],
      cateId: 0,
      MoocTalkLoadlist: [],
      countlist: 0,
      pageIndex: 1,
      pageSize: 5,
      routeFlag: true,
      MoocGetDownListlist: [],
      id: this.$route.query.id,
      Detailflg: false,
      TeacherInfo: [],
      trainId: this.$route.query.trainId ? this.$route.query.trainId : 0,
    };
  },
  mounted() {
    this.GetCourseDetail();
    this.GetIndexTree();
    this.GetTeacherInfoListst();
  },
  methods: {
    retrungo() {
      this.$router.push('/home');
    },
    // 关闭练习题
    Close(val) {
      this.routeFlag = true;
    },
    // 点击前往练习
    goexerciseitem(id) {
      let _this = this;
      _this.cateId == 2;
      _this.routeFlag = false;
      this.ids = id;
    },
    // 查询详情
    GetCourseDetail() {
      let data = { id: this.id };
      studyClassIndex.GetCourseDetail(data).then((res) => {
        // console.log(res);
        this.Detailflg = true;
        this.Detail = res.result;
      });
    },
    // 查询课程讲师
    GetTeacherInfoListst() {
      let data = { courseId: this.id };
      studyClassIndex.GetTeacherInfoList(data).then((res) => {
        // console.log(res);
        this.TeacherInfo = res.result;
      });
    },

    // 查询课程目录
    GetIndexTree() {
      let data = { courseId: this.id };
      studyClassIndex.GetIndexTree(data).then((res) => {
        // console.log(res);
        this.Treelist = res.result;
      });
    },
    // 查询下载列表
    MoocGetDownList() {
      let data = { id: this.id };
      studyClassIndex.MoocGetDownList(data).then((res) => {
        this.MoocGetDownListlist = res.result;
      });
    },

    // 点击立即下载
    downloadNow(id) {
      let data = { id: id };
      studyClassIndex.MoocGetDownFile(data).then((res) => {
        // console.log(res);
        window.location.href = res.result;
      });
    },
    // 查询评论列表
    Assistload() {
      let data = {
        courseId: this.id,
        page: this.pageIndex,
        limit: this.pageSize,
      };
      studyClassIndex.MoocTalkLoad(data).then((res) => {
        // console.log(res);
        this.MoocTalkLoadlist = res.data;
        this.countlist = res.count;
      });
    },
    // 跳入教官详情
    teacke(id) {
      this.$router.push('/diaoa/personData?id=' + id);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.Assistload();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.Assistload();
    },
    // 课后练习目录
    GetLearnDetail() {
      let data = { id: this.id };
      studyClassIndex.GetLearnDetail(data).then((res) => {
        // console.log(res);
        this.GetLearnDetaillist = res.result;
      });
    },
    // 跳转资源列表
    source(oneid, towid, thereid) {
      // console.log(oneid, towid, thereid);
      this.$router.push(
        '/studyclass?id=' +
          this.id +
          '&sourcenIdOne=' +
          oneid +
          '&catalogueId=' +
          towid +
          '&sourceId=' +
          thereid +
          '&trainId=' +
          this.trainId
      );
    },
    // tab切换
    handleClicktab(index) {
      this.cateId = index;
      this.pageIndex = 1;
      // console.log(index);
      if (index == 0) {
        this.GetIndexTree();
      } else if (index == 1) {
        this.Assistload();
      } else if (index == 2) {
        this.GetLearnDetail();
      } else if (index == 3) {
        this.MoocGetDownList();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.towheder {
  background-color: #d7d7d7;
  padding-bottom: 20px;
  .towhedercente {
    width: 1200px;
    margin: 0 auto;
    .twohederTitle {
      height: 20px;
      line-height: 20px;
      font-size: 18px;
    }
    .towhedrdetail {
      background-color: #fff;
      display: flex;
      padding: 20px;
      border-radius: 10px;
      img {
        width: 400px;
        height: 200px;
        border-radius: 5px;
      }
      .towdetailright {
        flex: 1;
        padding: 0 20px;
        .towdetailtops {
          font-size: 18px;
          display: flex;
          .towdetailtopstxt {
            flex: 1;
          }
        }
      }
      .towdetaillef {
        display: flex;
        align-items: center;
        font-size: 16px;
        color: #888;
        margin-top: 50px;
        i {
          margin: 0 10px;
        }
      }
    }
  }
}
.giveNumber {
  display: flex;
  margin-top: 50px;
  .givel {
    flex: 1;
  }
  .givenumberright {
    display: flex;

    .giveimg {
      display: flex;
      align-items: center;
      margin-right: 20px;
      img {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }
    }
  }
}
// ----
.classdetailtab {
  background-color: #fff;
  box-shadow: rgb(170 170 170 / 35%) 0px 4px 12px;
  // margin-top: 30px;
}
.ulisact {
  display: flex;
  width: 1200px;
  margin: 0 auto;
  height: 60px;
  line-height: 60px;
}
.ulisact li {
  display: inline-block;
  flex: 1;
  font-size: 18px;
  text-align: center;
  position: relative;
  padding: 0 10px;
}
.isactivescolor {
  color: rgb(2, 125, 180);
}
.isactives::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;
  width: 70px;
  height: 3px;
  background-color: rgb(2, 125, 180);
  z-index: 1;
}
.brieftext {
  width: 1160px;
  background-color: #fff;
  font-size: 14px;
  padding: 20px;
  border-radius: 10px;
  margin: 0 auto;
  margin-top: 20px;
  box-shadow: rgb(215 215 215 / 35%) 3px 3px 10px;
  line-height: 20px;
  letter-spacing: 1px;
  color: #888;
}
.classcouest {
  display: flex;
  justify-content: space-between;

  margin: 0 auto;
  width: 1200px;
  margin-top: 30px;
  min-height: 400px;
}
.classcouestleft {
  width: 720px;
  // box-shadow: 0 8px 16px 0 rgb(7 17 27 / 10%);
}
.classcouestleftli {
  padding: 20px 0;
  border-radius: 10px;
}
.classjd {
  font-size: 18px;
  font-weight: bold;
  height: 56px;
  line-height: 56px;
  background-color: #f7f7f7;
  padding-left: 16px;
}

.sounImgbox {
  display: flex;
  align-items: center;
  padding: 5px 32px;
}
.sounname {
  font-size: 14px;
  flex: 1;
  padding: 10px 16px;
}
.sounImg {
  width: 20px;
  height: 20px;
  margin: 0 2px;
}
// ---
.classcouestright {
  width: 340px;
  background-color: #fff;
  box-shadow: 2px 2px 5px rgb(215 215 215 / 65%);
  border-radius: 10px;
}
.classcouestrighthed {
  padding: 20px 10px;
}

.classcouestrightheditem {
  display: flex;
  label {
    font-size: 16px;
    font-weight: bold;
  }
  div {
    flex: 1;
    text-align: right;
    font-size: 14px;
  }
}
.studyx {
  height: 35px;
  border-radius: 17px;
  background-color: #50def9;
  width: 100%;
  color: #fff;
  font-size: 16px;
  text-align: center;
  line-height: 35px;
  margin-top: 20px;
}
.progress {
  width: 100%;
  height: 16px;
  background: rgba(28, 31, 33, 0.1);
  border-radius: 8px;
  position: relative;
  margin-top: 15px;
  ins {
    position: absolute;
    top: 0;
    left: 0;
    height: 16px;
    content: '';
    width: 0%;
    transition: 2s width;
    background: linear-gradient(
      to right,
      rgb(150, 217, 248),
      rgba(135, 245, 162)
    );
    border-radius: 8px;
  }
}

.introducel {
  height: auto;
  width: 1200px;
  background-color: rgba(255, 255, 255, 1);
  margin: 0 auto;
  margin-top: 30px;
  min-height: 400px;
  padding-bottom: 50px;
  .gaishu {
    text-align: justify;
    text-justify: newspaper;
    word-break: break-all;
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    border: 1px solid rgba(255, 255, 255, 1);
    // box-shadow: 3px 3px 8px rgb(127 127 127 / 35%);
    padding: 10px;
    color: #555555;
    margin-bottom: 20px;
    display: flex;
    border-bottom-color: #e5e9ef;

    .gaiimg {
      width: 45px;
      height: 45px;
      border-radius: 50%;
    }
    .gaisuflex {
      flex: 1;
      padding-left: 20px;
      .gaisuname {
        font-size: 17px;
        font-weight: bold;
      }
      .gaisutext {
        font-size: 16px;
        color: #555555;
        padding-top: 10px;
        padding-right: 10px;
        line-height: 22px;
      }
      .giveclbox {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        .give-time {
          color: rgba(0, 0, 0, 0.349019607843137);
        }
        .givecl {
          display: flex;
          align-items: center;
          margin-top: 10px;
          background-color: #888;
          height: 30px;
          width: 75px;
          border-radius: 15px;
          justify-content: center;
          color: #fff;
          img {
            height: 15px;
            width: 15px;
            margin-right: 5px;
          }
        }
      }
    }
  }
}

// --
.exercisebox {
  width: 1200px;
  margin: 0 auto;
  margin-top: 30px;
  min-height: 400px;
  padding-bottom: 50px;
}
.exerciseli {
  background-color: #fff;
  margin-bottom: 25px;
  label {
    font-size: 16px;
    font-weight: bold;
  }
  .exerciseitem {
    display: flex;
    padding: 20px;
    border-radius: 10px;
    box-shadow: rgb(215 215 215 / 35%) 3px 3px 10px;
    margin-top: 10px;
    .exerciseitemflex {
      flex: 1;
      li:nth-child(1) {
        padding-bottom: 10px;
      }
    }
    .exerciseitemRight {
      width: 180px;
      display: flex;
      align-items: center;
      .exerciseitemBtn {
        width: 100px;
        height: 40px;
        border-radius: 5px;
        background-color: rgb(3, 157, 18);
        color: #fff;
        text-align: center;
        line-height: 40px;
      }
    }
  }
}
// --
.downloadbox {
  width: 1200px;
  margin: 0 auto;
  margin-top: 30px;
  min-height: 400px;
  padding-bottom: 50px;
  .downloadli {
    padding: 20px;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: rgb(215 215 215 / 35%) 3px 3px 10px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    .downtxt {
      font-size: 16px;
      font-weight: bold;
      flex: 1;
    }
    .downbtn {
      width: 100px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 5px;
      background-color: rgb(3, 157, 18);
      color: #fff;
      font-size: 16px;
    }
  }
}
.score {
  font-size: 30px;
  text-decoration: none;
  color: #02a7f0;
}

.tag {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #999;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  margin-right: 8px;
  padding: 1px 4px;
}
.cnomert {
  // height: 100%;
}
.classcouestboxsum {
  min-height: 400px;
  padding-bottom: 50px;
}

.sourconts:hover {
  color: #00c758;
  cursor: pointer;
}

.teachli {
  padding-top: 20px;
}
.techliNamehed {
  padding: 10px;
  font-size: 16px;
  font-weight: bold;
}
.teachImgs {
  width: 96px;
  height: 96px;
}

.lecturerbox {
  border-radius: 10px;
  // box-shadow: rgb(215 215 215 / 35%) 3px 3px 10px;
  padding: 20px 10px;
  font-size: 16px;
}
.lecturer {
  display: flex;
  margin-bottom: 20px;
}
.lectureName {
  flex: 1;
  padding-left: 10px;
}
.lectureName h4 {
  margin-top: 10px;
}
.lecturegrade {
  margin-top: 20px;
}
.headersts {
  height: 60px;
  width: 100%;
  background-color: rgba(50, 65, 96, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(50, 65, 96, 1);
  border-radius: 0px;
  line-height: 60px;
  font-size: 16px;
  color: #fff;
  font-weight: 600;
}

.imgsts {
  margin-left: 18%;
  width: 40px;
  height: 40px;
  vertical-align: middle;
  cursor: pointer;
}
</style>
